import React, {Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import Spinner from "./components/spinner/Spinner";
import {PersistGate} from 'redux-persist/integration/react'
import {persistor, store} from "./redux/store";
import {Provider} from "react-redux";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const container = document.getElementById('root');
const root = createRoot(container!);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: 5 * 60 * 1000, // 5 dakika
        },
    },
});

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={<Spinner/>}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <App/>
                    </BrowserRouter>
                </QueryClientProvider>
            </Suspense>
        </PersistGate>
    </Provider>
);
